module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[77]564.311931a.woff2";